import { apiPost, apiPut } from "@redriver/cinnamon";

const NAMESPACE = "SETTINGS/RESTRICTIONS/PAPER_INCLUSIVE";

const ActionTypes = {
  UpdatePaperInclusiveRestrictions: `${NAMESPACE}/UPDATE`,
};

export const setPaperInclusiveRestrictions = (
  { templateUpload, ...data },
  { settingsId, dealerOfficeId, uploadDoc },
) => {
  const templateUploadObject = !uploadDoc
    ? null
    : {
        name: templateUpload.name,
        content: uploadDoc.split(",")[1],
        size: templateUpload.size,
        contentType: templateUpload.type,
      };
  return apiPut(
    ActionTypes.UpdatePaperInclusiveRestrictions,
    `defaults-restrictions/${settingsId}`,
    {
      dealerOfficeId,
      templateUpload: templateUploadObject,
      masterDescription: data.masterDescription,
      boilerPlateCode: data.boilerPlateCode,
      variablesNumber: data.variablesNumber,
      paperInclusive: {
        ...data,
      },
    },
  );
};
